export abstract class SingleRunResolver {
  resolve() {
    return this.runOnce();
  }

  protected abstract runOnce();
}
